export default __webpack_public_path__ + "media/monsters/02-b8a4e21e.png";